export const SEARCH_PAGE_COUNT = 20;
export const REQUEST_SEARCH = 'REQUEST_SEARCH';
export const RECEIVE_SEARCH = 'RECEIVE_SEARCH';
export const RECEIVE_SEARCH_UPDATE = 'RECEIVE_SEARCH_UPDATE';
export const SET_SEARCH_CONTEXT = 'SET_SEARCH_CONTEXT';

export const SEARCH_CONTEXT_PRODUCTS = 'products';
export const SEARCH_CONTEXT_ANIMAL_HUSBANDRY = 'Животноводство';
export const SEARCH_CONTEXT_CROP_PRODUCTION = 'Растениеводство';
export const SEARCH_CONTEXT_TECHNIQUE = 'Техника';
export const SEARCH_CONTEXT_MANUFACTURING = 'Продукты питания и напитки';
export const SEARCH_CONTEXT_ANOTHER_PRODUCTS = 'Услуги';

export const SEARCH_CONTEXT_UNSET = '/';
